import httpService from "./httpService";

export default {
  findByHcCaseCommandsId(hcCaseCommandsId) {
    let params = {hcCaseCommandsId: hcCaseCommandsId};
    return httpService.get("/hcCaseCommandsUser/findByHcCaseCommandsId", {
      params: params
    });
  }
};



// WEBPACK FOOTER //
// ./src/services/hcCaseCommandsUserService.js